import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

const loadEmbeddedPdf = function (element: HTMLElement, embeddedElement: HTMLElement, newValue: string) {
    ko.virtualElements.emptyNode(element);

    if (newValue) {
        $(embeddedElement).attr("type", "application/pdf");
        $(embeddedElement).attr("src", newValue);
        $(embeddedElement).clone().appendTo(element);
    }
};

register.registerKnockoutBinding("pdf", {
    init: function (element, valueAccessor) {
        const sourceObs = valueAccessor();
        const embeddedElement = $(element).children("embed")[0];

        ko.virtualElements.emptyNode(element);

        sourceObs.subscribe(function (newValue: string) {
            loadEmbeddedPdf(element, embeddedElement, newValue);
        });

        loadEmbeddedPdf(element, embeddedElement, ko.unwrap(sourceObs));
    }
});

const loadEmbeddedPdfContent = function (element: HTMLElement, embeddedElement: HTMLElement, newValue: string) {
    ko.virtualElements.emptyNode(element);

    if (newValue) {
        const blob = new Blob([newValue], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(blob);

        $(embeddedElement).attr("type", "application/pdf");
        $(embeddedElement).attr("src", fileUrl);
        $(embeddedElement).clone().appendTo(element);
    }
};

register.registerKnockoutBinding("pdfContent", {
    init: function (element, valueAccessor) {
        const sourceObs = valueAccessor();
        const embeddedElement = $(element).children("embed")[0];

        ko.virtualElements.emptyNode(element);

        sourceObs.subscribe(function (newValue: string) {
            loadEmbeddedPdfContent(element, embeddedElement, newValue);
        });

        loadEmbeddedPdfContent(element, embeddedElement, ko.unwrap(sourceObs));
    }
});
